import axios, { AxiosInstance } from "axios";
import { BASE_URL } from "../config/api";

const LOGIN_PATH = "/login";
const PUBLIC_SHARE_PATH_PREFIX = "/share/";
const DEALER_PATH_PREFIX = "/dealer/";

const isDealerHost = () =>
  window.location.hostname.toLowerCase().startsWith("dealer.");

const clearAuthSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  sessionStorage.clear();
};

const redirectToLogin = () => {
  const currentPath = window.location.pathname;
  if (
    isDealerHost() ||
    currentPath === LOGIN_PATH ||
    currentPath.startsWith(PUBLIC_SHARE_PATH_PREFIX) ||
    currentPath.startsWith(DEALER_PATH_PREFIX)
  ) {
    return;
  }

  window.location.replace(LOGIN_PATH);
};

const apiInstance: AxiosInstance = axios.create({
  baseURL: BASE_URL,
});

apiInstance.interceptors.request.use(
  async (config: any) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    // The browser must add the multipart boundary for FormData requests.
    // Setting Content-Type manually can produce an unreadable upload body.
    if (config.data instanceof FormData && config.headers) {
      config.headers.setContentType?.(undefined);
      config.headers.delete?.("Content-Type");
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAuthSession();
      redirectToLogin();
    }

    return Promise.reject(error);
  }
);

export default apiInstance;
